import {WeaTools} from 'ecCom';

/**
 * 获取本地Cookie数据
 *
 */
export const getCookieValue = (name) => {
    let value = '';

    const cookie = document.cookie;
    const list = cookie.split('; ');
    for(var i = 0, len = list.length; i < len; i++) {
        var arr = list[i].split('=');
        if(arr[0] == name) {
            value = arr[1];
        }
    }

    if (value == 'true') {
        value = true;
    } else if (value == 'false') {
        value = false;
    }

    return value;
};

/**
 * 获取本地缓存数据
 *
 */
export const getLSValue = (key1, key2) => {
    const obj = WeaTools.ls.getJSONObj(key1);
    return obj && obj[key2];
};

/**
 * 设置本地缓存数据
 *
 */
export const setLSValue = (key1, key2, value) => {
    const obj = WeaTools.ls.getJSONObj(key1) || {};
    obj[key2] = value;
    WeaTools.ls.set(key1, obj);
};

/**
 * 初始化本地缓存数据
 *
 */
export const initLSValue = (loginId, langId) => {
    const _loginId = getLSValue('login', 'loginId');
    const _langId = getLSValue('login', 'langId');

    const ls = window.localStorage;
    const keys = [];
    if (!_loginId || !_langId || loginId != _loginId || langId != _langId) {
        keys.push('e9_locale');
        for (let i = 0, len = ls.length; i < len; i++) {
            const key = ls.key(i);
            if (/^theme-/.test(key) || /^portal-/.test(key) || /^edata-/.test(key) || /^tabdata-/.test(key)) {
                keys.push(key);
            }
        }
    }

    for (let i = 0, len = keys.length; i < len; i++) {
        ls.removeItem(keys[i]);
    }

    WeaTools.ls.set('isInitLSValue', true);
};

/**
 * 获取登录背景图片样式
 *
 */
export const getLoginBgImageStyle = (loginInfo) => {
    const {fillStyle} = loginInfo;
    const src = getLSValue('login', 'loginBgImage') || loginInfo.imgsrc;
    const width = getLSValue('login', 'loginBgImageWidth') || loginInfo.width;
    const height = getLSValue('login', 'loginBgImageHeight') || loginInfo.height;

    let style = {backgroundImage: 'url(' + src + ')'};
    switch (fillStyle) {
        case 'adapt':
        case 'fill':
            style.backgroundRepeat = 'no-repeat';
            style.backgroundSize = 'cover';
            let _style = {};
            let win_width = jQuery(window).width();
            let win_height = jQuery(window).height();
            win_width = win_width < 800 ? 800 : win_width;
            win_height = win_height < 712 ? 712 : win_height;
            let rate = width / height;
            let _rate = win_width / win_height;
            if (rate > _rate) {
                if (fillStyle == 'adapt') {
                    _style = {
                        width: win_width,
                        height: win_width / rate,
                        marginTop: (win_height - win_width / rate) / 2
                    }
                }
                if (fillStyle == 'fill') {
                    _style = {
                        width: win_height * rate,
                        height: win_height,
                        marginLeft: -((win_height * rate - win_width) / 2)
                    }
                }
            } else if (rate < _rate) {
                if (fillStyle == 'adapt') {
                    _style = {
                        width: win_height * rate,
                        height: win_height,
                        marginLeft: (win_width - win_height * rate) / 2
                    }
                }
                if (fillStyle == 'fill') {
                    _style = {
                        width: win_width,
                        height: win_width / rate
                    }
                }
            } else {
                _style = {
                    width: win_width,
                    height: win_height
                }
            }
            style = {...style, ..._style};
            break;
        case 'tile':
            style.backgroundRepeat = 'repeat';
            break;
        case 'center':
            style.backgroundPosition = 'center';
            style.backgroundRepeat = 'no-repeat';
            break;
        default:
            style.backgroundRepeat = 'no-repeat';
            style.backgroundSize = '100% 100%';
            break;
    }
    return style;
};



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/util/loginUtil.js